import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { BiCheckCircle } from 'react-icons/bi';
import serverurl from '../utils/ServerUrl';

export default function OrderSuccessSummary() {
    const [successData, setSuccessData] = useState([])
    const [loading, setLoading] = useState(true)
    const { tranId } = useParams();
    // const tranId ="e36a2bfe-af18-4a0f-86b3-33f67d591764";

    useEffect(() => {
        window.scrollTo(0, 0)
        fetch(`${serverurl}/validate/${tranId}`)
            .then(response => response.json()).then((res) => {
                setSuccessData(res)
                setLoading(false)

            })
            .catch((err) => {
                console.log(err.message)
            });
    }, [tranId])

    // console.log(successData);

    if (loading) { return (<div>loading..</div>) }

    return (
        <div className='bg-gray-200'>
            <div className='container mx-auto  sm:p-0 md:p-5'>
                <div className='bg-white grid grid-cols-5 pt-5 p-4'>
                    <div className='md:col-span-2 col-span-5'>
                        <div className='bg-gray-50 mt-3 p-3'>
                            <div className="mark-icon text-center">
                                <div className='w-full flex justify-center'>
                                    <BiCheckCircle className='text-4xl font-bold text-green-600' />
                                </div>
                                <h3 className='text-2xl font-normal text-gray-600 mb-3'>Thank you for your online purchase</h3>
                                <p className='t text-gray-600'>This is a confirmation and summary of your order which is currently being processed.</p>
                            </div>
                            <div className='p-4'>
                                {
                                    [successData].map((item) => (
                                        <ul className="list-disc">
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Order Id : <span className='font-semibold'>{item?._id}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Date : <span className='font-semibold'>{item?.PlacedDate}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Email : <span className='font-semibold'>{item?.contactInfo.email}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Total : <span className='font-semibold'>{item?.totalPrice} BDT</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Payment : <span className='font-semibold'>{item?.paidStatus}</span></li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='grid md:col-span-3 col-span-5  mt-3 md:p-3'>
                        <h3 className='text-2xl font-poppins text-gray-500 pb-3 mb-2 border-b'>Order Details</h3>
                        {/* ///////////////////////////////////////////////////////////////////// */}


                        <table className="table-auto w-full">
                            <thead>
                                <tr className='border-b-2'>
                                    <th className='w-28 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 '></th>
                                    <th className='w-48 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>Name</th>
                                    <th className='w-24 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>quantity</th>
                                    <th className='w-20 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600 md:block hidden'>price</th>
                                    <th className='w-20 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 text-end'>total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {successData?.itemIds?.length > 0 ?
                                    successData?.itemIds.map((item, i) => (
                                        <tr key={i} className='border-b'>
                                            <td className=''>
                                                <img className='h-16 md:m-2 object-contain' src={item.img} alt="" />
                                            </td>
                                            <td className='text-gray-600 py-3 px-2 md:text-base text-xs'>{item.name.length > 32 ? (item.name.substring(32, 0) + "..") : item.name}</td>
                                            <td className='text-center p-3 md:text-base text-xs'>{item.quantity}</td>
                                            <td className='md:block text-center relative md:-top-8 md:text-base text-xs'>{item.price}</td>
                                            <td className='text-end py-3 pr-3 md:text-base text-xs'>{item.total}</td>
                                        </tr>
                                    ))
                                    :
                                    <div className='p-3 text-center w-full'>
                                        <h3 className='text-center w-full'>Empty 😊</h3>
                                    </div>
                                }

                            </tbody>
                        </table>
                        {/* //////////////////////////////////////////////////////////////////////// */}
                        <div>
                            <div className='py-2 mt-1 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Bill Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                            <div className='py-2 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Shipping Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
